import { Modal, Typography } from '@sunrun/experience-ui-components';
import { WORKDAY_URL } from 'constants/workday';

type LogHoursReminderModalV1Props = {
  onClose: () => void;
};

const LogHoursReminderModalV1 = ({ onClose }: LogHoursReminderModalV1Props) => {
  const handleLogHours = () => {
    window.open(WORKDAY_URL, '_blank');
    onClose();
  };

  return (
    // Stop mousedown propagation so RecheckVerificationPrompt's Modal useClickOutside
    // from component lib doesn't treat this modal's button clicks as "outside" and close that modal too when stacked.
    <div onMouseDown={(e) => e.stopPropagation()}>
      <Modal
        customModalWidth={800}
        testId="log-hours-modal-reminder"
        onClose={onClose}
        type="info"
        title="Log hours in Workday"
        secondaryButton={{
          text: 'Close',
          onClick: onClose,
        }}
        primaryButton={{
          text: 'Log hours',
          onClick: handleLogHours,
        }}>
        <br />
        <Typography>Remember to log your hours daily in Workday.</Typography>
        <br />
      </Modal>
    </div>
  );
};

export { LogHoursReminderModalV1 };
